import {
  AllProductsIcon,
  ExtractIcon,
  FlowerIcon,
  GearIcon,
  GrowIcon,
  GummyIcon,
  JaneGoldIcon,
  MerchIcon,
  PrerollIcon,
  StarFilledIcon,
  TagFilledIcon,
  TinctureIcon,
  TopicalIcon,
  VapeIcon,
} from '@iheartjane/reefer';
import type { ColorKey, IconComponentProps } from '@iheartjane/reefer';

import type { MenuCategoryPath } from '@jane/shared/types';

export interface MenuCategory {
  color: ColorKey;
  Icon: IconComponentProps;
  iconColor?: ColorKey;
}

interface MenuCategoryTabs {
  [category: string | MenuCategoryPath]: MenuCategory;
}

export const MENU_CATEGORY_TABS: MenuCategoryTabs = {
  featured: {
    Icon: StarFilledIcon,
    color: 'gold-light',
  },
  specials: {
    Icon: TagFilledIcon,
    color: 'sunset-light',
    iconColor: 'sunset',
  },
  'jane-gold': {
    Icon: JaneGoldIcon,
    color: 'gold-light',
    iconColor: 'gold',
  },
  flower: {
    Icon: FlowerIcon,
    color: 'purple-light',
  },
  edible: {
    Icon: GummyIcon,
    color: 'tangerine-light',
  },
  'pre-roll': {
    Icon: PrerollIcon,
    color: 'ember-light',
  },
  extract: {
    Icon: ExtractIcon,
    color: 'gold-light',
  },
  tincture: {
    Icon: TinctureIcon,
    color: 'grape-light',
  },
  topical: {
    Icon: TopicalIcon,
    color: 'sunset-light',
  },
  vape: {
    Icon: VapeIcon,
    color: 'sunset-light',
  },
  merch: {
    Icon: MerchIcon,
    color: 'palm-light',
  },
  gear: {
    Icon: GearIcon,
    color: 'seafoam-light',
    iconColor: 'seafoam',
  },
  grow: {
    Icon: GrowIcon,
    color: 'palm-light',
  },
  all: {
    Icon: AllProductsIcon,
    color: 'purple-light',
  },
};
